import {useMutation} from "@tanstack/react-query";
import {API} from "../../api";

export const useDeleteFeatureMutation = (onSuccess, onError) => {
  return useMutation({
    mutationFn: API.deleteFeatureFlag,
    onSuccess,
    onError: (err) => {
      if (onError) {
        onError(err);
      }
      console.error(err);
    },
  });
};
